<!--
 * @Author: M.D.
 * @Date: 2019-12-09 13:42:46
 * @LastEditors: M.D.
 * @Description:
 * @Remarks:
 -->
<template>
  <div class="top-header1">
    <div class="ltr">
      <ul class="handle">
        <li class="item tp-chos-loc" v-if="!memberInfo.username">
          <toggle-loca></toggle-loca>
        </li>
        <li
          class="login-btn1"
          @click="loginDialog = true"
          v-if="!memberInfo.username"
        >
          登录
        </li>
        <!-- <router-link class="item i-usr-name" :to="{'name':'user'}" tag="li" v-if="memberInfo.username">{{memberInfo.username}}</router-link> -->
        <el-dropdown v-if="memberInfo.username" @command="handleCommand">
          <span class="el-dropdown-link item i-usr-name" @click="userCenter">
            {{ memberInfo.username
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="1"
              >我的消息<span
                v-if="unreadNum > 0"
                style="color: red; margin-left: 4px"
                >({{ unreadNum }})</span
              ></el-dropdown-item
            >
            <el-dropdown-item command="2">我的订单</el-dropdown-item>
            <el-dropdown-item command="3">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <!-- <div class="left_c">
          <el-button
            v-if="memberInfo.username"
            type="primary"
            plain
            size="small"
            round
            >下载</el-button
          >
        </div> -->
        <!-- <a v-if="memberInfo.username" class="hg-btn" @click="downloadfile"
          >全电手册</a
        > -->

        <li
          class="zhuce-btn"
          @click="regDialog = true"
          v-if="!memberInfo.username"
        >
          立即注册
        </li>
        <!-- <li class="item" @click="loginOutConfirm" v-if="userInfo.username">退出</li> -->
      </ul>
    </div>

    <!-- 登录Dialog -->
    <el-dialog
      ref="loginDialog"
      :visible.sync="loginDialog"
      :close-on-click-modal="false"
      @opened="loginDialOpened"
      class="login-dialog"
      width="30%"
    >
      <div class="login-tabs">
        <el-tabs v-model="activeName" @tab-click="changTabIdx" class="or-tab">
          <el-tab-pane label="账号登录" name="pass">
            <div class="u-wrapper wrapper">
              <el-input
                placeholder="请输入手机号/账号"
                v-model="username"
                :disabled="usrDisabled"
                @keyup.enter.native="login"
                clearable
              >
              </el-input>
            </div>
            <div class="p-wrapper wrapper">
              <el-input
                placeholder="请输入密码"
                @keyup.enter.native="login"
                v-model="password"
                show-password
              ></el-input>
            </div>
            <div
              class="p-wrapper wrapper"
              v-if="loginByMobile && usrAccounts.length > 1"
            >
              <el-select
                style="width: 100%"
                v-model="accountFromMobile"
                placeholder="请选择登录账号"
              >
                <el-option
                  v-for="item in usrAccounts"
                  :key="item.username"
                  :label="item.username"
                  :value="item.username"
                >
                </el-option>
              </el-select>
            </div>
            <div class="p-wrapper wrapper">
              <pic-auth-code
                ref="picAuthCode"
                @enterFire="login"
                v-model="picAuthCode"
              />
            </div>
            <div class="b-wrapper wrapper">
              <el-button
                type="primary"
                class="login-btn"
                @click="login"
                :disabled="loginBtnDisabled"
                >立即登录</el-button
              >
              <!-- <a v-if="memberInfo.username" class="hg-btn" @click="downloadfile"
                >全电手册</a
              > -->
            </div>
            <!-- <div @click="downloadfile">全电控件下载</div> -->
          </el-tab-pane>
          <el-tab-pane label="二维码登录" name="wx">
            <div class="qr-wrapper">
              <canvas id="canvas"></canvas>
              <div
                v-if="usrQrAccounts.length > 0"
                style="
                  position: absolute;
                  top: 0px;
                  width: 200px;
                  height: 200px;
                  text-align: center;
                "
              >
                <div
                  style="
                    position: relative;
                    top: 0px;
                    width: 200px;
                    height: 200px;
                    background-color: white;
                    opacity: 0.95;
                  "
                ></div>
                <img
                  style="
                    z-index: 99;
                    width: 90px;
                    height: 55px;
                    opacity: 1;
                    position: absolute;
                    top: 36%;
                    left: 27%;
                  "
                  :src="require('@/assets/image/scan_success.png')"
                />
              </div>
              <div
                v-if="usrQrAccounts.length > 1"
                style="
                  width: 100%;
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                "
              >
                <el-select
                  @change="loginSelectedAccount"
                  style="width: 70%"
                  v-model="accountFromQr"
                  placeholder="请选择登录账号"
                >
                  <el-option
                    v-for="item in usrQrAccounts"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
                <el-button type="primary" @click="bindNewAccount"
                  >绑定新账号</el-button
                >
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="tp-lg-dialog-footer">
        <div class="l">
          没有账号？<el-button @click="goRegister" type="text"
            >立即注册</el-button
          ><el-button @click="downloadfile" type="text"
            >全电发票控件下载</el-button
          >
        </div>
        <el-button @click="goFgPwd" type="primary">忘记密码</el-button>
      </div>
    </el-dialog>

    <!-- 注册Dialog -->
    <el-dialog
      ref="regDialog"
      :visible.sync="regDialog"
      :close-on-click-modal="false"
      @close="resetRegForm"
      class="reg-dialog"
      width="850px"
    >
      <div class="tp-reg-dia-header" slot="title">企业服务平台欢迎您</div>

      <!-- 注册表单 -->
      <div class="tp-form-w">
        <el-form
          ref="regForm"
          :model="regForm"
          label-position="right"
          label-width="125px"
        >
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="tp-f-item">
                <el-form-item
                  label="手机号码"
                  class="u-pwd-phone"
                  prop="phone"
                  :rules="rule.phone"
                >
                  <el-input
                    placeholder="请输入手机号码"
                    v-model="regForm.phone"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="tp-f-item">
                <el-form-item
                  label="验证码"
                  class="u-pwd-auth-c"
                  prop="authCode"
                  :rules="rule.required"
                >
                  <!-- <auth-code :phoneNum="regForm.authCode" @authCodeChange="setNewAuthCode"></auth-code> -->
                  <auth-code
                    ref="regAuthCode"
                    :phoneNum="regForm.phone"
                    v-model="regForm.authCode"
                    @authCodeChange="setRegAuthCode"
                  ></auth-code>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item label="设置账户名" prop="usrName">
                  <el-input
                    placeholder="请设置账户名"
                    v-model="regForm.usrName"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <!-- <el-col :span="12">
              <div class="grid-content">
                <el-form-item
                  label="地区"
                  prop="areaCode"
                  :rules="reginValidator"
                >
                  <el-cascader
                    style="width: 270px"
                    @change="getAreaTxtLo"
                    v-model="regForm.areaCode"
                    :props="{ checkStrictly: true, expandTrigger: 'click' }"
                    :options="regOptions"
                  >
                  </el-cascader>
                </el-form-item>
              </div>
            </el-col> -->
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item label="设置新密码" prop="pwd" :rules="rule.pwd">
                  <el-input
                    type="password"
                    show-password
                    placeholder="请输入新密码（6-20个字符）"
                    v-model="regForm.pwd"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item
                  label="确认密码"
                  prop="repPwd"
                  :rules="repPwdValidator"
                >
                  <el-input
                    placeholder="请再次输入新密码"
                    type="password"
                    show-password
                    v-model="regForm.repPwd"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <!-- 全电信息 -->
          <div class="tishi">
            <el-checkbox
              v-model="zclx"
              true-label="2"
              false-label="1"
              :disabled="cancancel"
              @change="czlxchange"
              >全电发票</el-checkbox
            >
          </div>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item
                  label="社会信用代码"
                  prop="kpdwdm"
                  :rules="zclx == 2 ? qdrule.kpdwdm : [{ required: false }]"
                >
                  <el-input
                    placeholder="请输入社会信用代码"
                    v-model="regForm.kpdwdm"
                    :disabled="zclx == 1"
                    @blur="getQymc"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="12">
              <div class="grid-content">
                <el-form-item
                  label="纳税人名称"
                  prop="kpdwmc"
                  :rules="zclx == 2 ? qdrule.kpdwmc : [{ required: false }]"
                >
                  <el-input
                    placeholder="请输入纳税人名称"
                    v-model="regForm.kpdwmc"
                    :disabled="zclx == 1"
                  ></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item
                  label="电子税务局账号"
                  prop="dzswjzh"
                  :rules="zclx == 2 ? qdrule.dzswjzh : [{ required: false }]"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="请输入电子税务局账号"
                    placement="top"
                  >
                    <el-input
                      placeholder="请输入电子税务局账号"
                      v-model="regForm.dzswjzh"
                      :disabled="zclx == 1"
                    ></el-input>
                  </el-tooltip>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="12">
              <div class="grid-content">
                <el-form-item
                  label="电子税务局密码"
                  prop="dzswjmm"
                  :rules="zclx == 2 ? qdrule.dzswjmm : [{ required: false }]"
                >
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="请输入电子税务局密码"
                    placement="top"
                  >
                    <el-input
                      placeholder="请输入电子税务局密码"
                      v-model="regForm.dzswjmm"
                      :disabled="zclx == 1"
                    ></el-input>
                  </el-tooltip>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <!-- 协议 -->
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="grid-content">
                <el-form-item label="">
                  <el-checkbox v-model="regForm.hasChkTrt" @change="onChkChange"
                    >请阅读并同意《用户服务协议》</el-checkbox
                  >
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <!-- 协议 -->
          <!-- <el-row>
              <el-col>
                <el-checkbox v-model="regForm.hasChkTrt" @change="onChkChange">请阅读并同意《用户服务协议》</el-checkbox>
              </el-col>
            </el-row> -->

          <el-row>
            <el-col :offset="6" :span="12">
              <div class="tp-rgbt-w tp-buttom-bt">
                <el-button
                  style="width: 60%"
                  class="btn"
                  type="primary"
                  @click="onRegSub"
                  >立即注册</el-button
                >
              </div>
            </el-col>
          </el-row>
          <!-- 返回登录 -->
          <el-row>
            <el-col :offset="6" :span="12">
              <div class="tp-bkbt-w tp-buttom-bt">
                已有账号？<el-button @click="toLogin" type="text"
                  >返回登录</el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>

    <!-- 忘记密码 -->
    <forget-password
      @fgtShowUpdate="fgtShowUpdate"
      :dialogShow="fgPwdDialog"
      ref="forgetPasswordDialog"
    />

    <!-- 合并账号dialog -->
    <comp-account
      :start="needMerge"
      ref="compAccount"
      @toLogin="toLogFromComp"
      :wxStateStr="qRState"
      @visChg="_visUpdate"
    >
    </comp-account>

    <agreement cateId="11" @agrShowHandler="agrShowHandler" :agShow="agShow" />
  </div>
</template>

<script>
import API from '@/api/api'
import { mapActions, mapGetters } from 'vuex'
import { areaData, getAreaTxt } from '@/util/area'
import QRCode from 'qrcode'
import rule from '@/util/rule'
import Agreement from '@/components/agreement'
import CompAccount from '@/components/comp-accout'
import AuthCode from '@/components/auth-code'
import ToggleLoca from '@/components/toggle-loca'
import PicAuthCode from '@/components/pic-auth-code'
import ForgetPassword from '@/components/forget-pswd'

export default {
  props: {},
  data() {
    return {
      cancancel: false,
      qdrule: {
        kpdwdm: [
          {
            required: true,
            message: '请输入社会信用代码',
            trigger: 'blur',
          },
          {
            min: 15,
            max: 20,
            message: '长度在 15 到 20 个字符',
            trigger: 'blur',
          },
        ],

        kpdwmc: [
          {
            required: true,
            message: '请输入纳税人名称',
            trigger: 'blur',
          },
        ],

        dzswjzh: [
          {
            required: true,
            message: '请输入电子税务局账号',
            trigger: 'blur',
          },
        ],
        dzswjmm: [
          {
            required: true,
            message: '请输入电子税务局密码',
            trigger: 'blur',
          },
        ],
      },
      zclx: '1', //注册类型
      picAuthCode: undefined,
      loginDialog: false,
      regDialog: false,
      fgPwdDialog: false,
      activeName: 'pass',
      agShow: false,
      // 登录
      username: '',
      loginByMobile: false,
      usrDisabled: false,
      usrAccounts: [],
      usrQrAccounts: [],
      accountFromMobile: '',
      accountFromQr: '',
      password: '',
      qRState: '',
      selectedLoginDialogtab: '',
      // 注册form
      regForm: {
        phone: '',
        authCode: '',
        usrName: '',
        areaCode: '', // 数组格式
        pwd: '',
        repPwd: '',

        dzswjzh: '',
        dzswjmm: '',
        kpdwmc: '',
        kpdwdm: '',
        hasChkTrt: false,
      },
      areaTxt: '',
      reginValidator: {
        required: true,
        validator: (rule, value, cb) => {
          if (!value) {
            return cb(new Error('地区不能为空'))
          } else if (value.length !== 3) {
            return cb(new Error('请选择省-市-区'))
          } else {
            cb()
          }
        },
      },
      repPwdValidator: {
        required: true,
        validator: (rule, value, cb) => {
          if (!value) {
            return cb(new Error('确认密码不能为空'))
          } else if (this.regForm.pwd !== value) {
            return cb(new Error('两次输入的密码不一致，请检查'))
          } else {
            cb()
          }
        },
        trigger: 'blur',
      },

      // 地区选择
      regOptions: areaData,

      rule,

      // 合并
      needMerge: false,
      loginBtnDisabled: false,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'memberInfo', 'unreadNum']),
  },
  created() {
    console.log(this)
    console.log('组件实例', this.servicePhone)
    if (this.$route.query.usrStatus === '201') {
      this._showCompD()
    }

    if (this.$route.query.op) {
      this.zclx = '2'
      this.cancancel = true
    }
  },
  mounted() {
    this.clickTextSelected()
  },
  activated() {},
  deactivated() {},
  watch: {
    usrQrAccounts: function(v) {
      if (!v || v.length === 0) {
        this.accountFromQr = ''
      }
    },
    username: function(v) {
      const reg = /^1[3456789]\d{9}$/
      if (reg.test(v)) {
        this.onInputMobile(v)
      } else {
        this.onInputMobile(null)
      }
    },
  },
  methods: {
    //
    downloadfile() {
      let n = Math.ceil(Math.random() * 10)
      let address =
        'https://www.chinaqjwx.cn/jsyw/File_down.interface?type=chromeReq.rar&tm=' +
        n
      let time = new Date().getTime()
      let val = address + '&time=' + time

      // window.open(val)
      window.location.href = val
    },
    //根据税号获取名称
    getQymc() {
      if (!this.regForm.kpdwdm) {
        return
      }
      let request = {
        sh: this.regForm.kpdwdm,
        isJson: true,
      }
      API.getQymc(request).then(res => {
        if (res.data.statusCode == 200) {
          this.regForm.kpdwmc = res.data.result
        }
      })
    },
    // 级联选择器点击文本选中
    clickTextSelected() {
      // 点击文本就让它自动点击前面的input就可以触发选择。但是因组件阻止了冒泡，暂时想不到好方法来触发。
      // 这种比较耗性能，暂时想不到其他的，能实现效果了。
      setInterval(function() {
        document.querySelectorAll('.el-cascader-node__label').forEach(el => {
          el.onclick = function() {
            if (this.previousElementSibling) this.previousElementSibling.click()
          }
        })
      }, 1000)
    },
    ...mapActions([
      'setUserInfo',
      'userLogOut',
      'setCurLoc',
      'getUnreadCount',
      'loginSucc',
    ]),
    fgtShowUpdate(v) {
      this.fgPwdDialog = v
      if (!v) {
        this.loginDialog = true
      }
    },
    bindNewAccount() {
      this.needMerge = true
      this.$refs.compAccount.showOtherInfo()
      this._hideLogD()
    },
    async onInputMobile(v) {
      if (!v) {
        this.usrDisabled = false
        this.loginByMobile = false
        this.usrAccounts = []
        this.accountFromMobile = ''
        return
      }
      this.usrDisabled = true
      try {
        const res = await API.getMembersByMobile({
          mobile: v,
        })
        if (res.data.statusCode === '200') {
          this.usrDisabled = false
          if (res.data.result.length === 0) {
            throw new Error('手机号未注册')
          } else {
            this.loginByMobile = true
            this.usrAccounts = res.data.result
            this.accountFromMobile = this.usrAccounts[0].username
          }
        } else {
          throw new Error(res.data.message)
        }
      } catch (error) {
        this.usrDisabled = false
        this.$message({
          message: error.message,
          type: 'error',
        })
      }
    },
    handleCommand(command) {
      if (command === '1') {
        this.$router
          .push({
            name: 'message',
          })
          .catch(error => {
            console.log(error)
          })
      } else if (command === '2') {
        this.$router
          .push({
            name: 'orders',
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.loginOutConfirm()
      }
    },
    userCenter() {
      this.$router
        .push({
          name: 'user',
        })
        .catch(error => {
          console.log(error)
        })
    },
    onChkChange(v) {
      if (v) {
        this.agShow = true
      }
    },
    agrShowHandler(v) {
      this.agShow = v
    },

    // 登录
    async login() {
      // 防止点击多次
      this.loginBtnDisabled = true
      let re = await API.webLogin({
        accountOrMobile: this.loginByMobile
          ? this.accountFromMobile
          : this.username,
        password: this.password,
        type: 0,
        code: this.picAuthCode || '',
      })

      if (re.data.statusCode === '200') {
        // this.setUserInfo(re.data.result)
        // this.setCurLoc([re.data.provinceCode, re.data.cityCode])
        this.loginSucc(re).then(res => {
          this.$message({
            message: '登录成功',
            type: 'success',
          })
          this.loginDialog = false
          this.loginBtnDisabled = false
          this.$emit('loginResult', true)

          console.log(re.data.result.dzswjzh)
          //如果存在去新时代全电的操作---就调用一键登录

          if (this.$route.query.op) {
            //先判断有没完善全电信息--
            if (re.data.result.dzswjzh) {
              this.$emit('openPay')
            } else {
              this.$alert('您还未完善全电相关信息，请先完善信息', '提示', {
                confirmButtonText: '确定',
                type: 'warning',
                showClose: false,
              }).then(() => {
                this.$router.push({
                  name: 'userInfo',
                  query: { op: 'qd' },
                })
              })
              //没有的话提示跳转到完善信息页面
            }
            //
          }
        })
      }
      // 验证码错误，更新图片验证码
      if (this.$refs.picAuthCode && re.data.statusCode === '300') {
        this.loginBtnDisabled = false
        this.$refs.picAuthCode.getValidateCode()
      }
    },

    // 二维码登录 - 获取二维码
    async getQrCode() {
      const re = await API.webLoginGetQrCode()
      if (re.data.statusCode === '200') {
        this.qRState = re.data.result.state
        this.drawQRCode(re.data.result.data)
        setTimeout(() => {
          this.getUsrInfoByPoll()
        }, 1000)
      }
    },
    drawQRCode(url) {
      var canvas = document.getElementById('canvas')
      QRCode.toCanvas(canvas, url, { width: 200 }, function(error) {
        if (error) console.error(error)
      })
    },
    // 轮询获取用户信息
    async getUsrInfoByPoll() {
      if (this.qRState !== '') {
        const re = await API.webGetUsrByPoll({ state: this.qRState })
        if (
          re.data.statusCode === '301' &&
          this.activeName === 'wx' &&
          this.loginDialog
        ) {
          setTimeout(() => {
            this.getUsrInfoByPoll()
          }, 1000)
        } else if (re.data.statusCode === '201') {
          // 完善用户信息
          this._showCompD()
        } else if (re.data.statusCode === '200') {
          // this.setUserInfo(re.data.result)
          this.loginSucc(re).then(res => {
            this.loginDialog = false
            this.$message({
              message: '登录成功',
              type: 'success',
            })
          })
        } else if (re.data.statusCode === '202') {
          // 本微信号的openid关联了多个账号，返回账号列表选择
          this.usrQrAccounts = re.data.result
          if (re.data.result.length === 1) {
            this.accountFromQr = this.usrQrAccounts[0]
            this.loginSelectedAccount(this.accountFromQr)
          }
        }
      }
    },
    // 获取联级节点值
    getAreaTxtLo(v) {
      this.areaTxt = getAreaTxt(v)
      this.$refs.regForm.validateField('areaCode') // 验证地区
    },
    // 注册提交
    onRegSub() {
      this.$refs.regForm.validate(async valid => {
        if (valid) {
          if (!this.regForm.hasChkTrt) {
            this.$message({ message: '请同意用户服务协议', type: 'error' })
            return
          }

          //如果注册全电，得添加参数
          let request = {
            zclx: this.zclx,
            mobile: this.regForm.phone,
            username: this.regForm.usrName,
            code: this.regForm.authCode,
            password: this.regForm.pwd,
            area: this.regForm.areaCode[2],
            city: this.regForm.areaCode[1],
            province: this.regForm.areaCode[0],
            region: this.areaTxt,
          }

          if (this.zclx == 2) {
            request.creditCode = this.regForm.kpdwdm
            request.taxpayerName = this.regForm.kpdwmc
            request.dzswjzh = this.regForm.dzswjzh
            request.dzswjmm = this.regForm.dzswjmm
          }
          const re = await API.webReg(request)

          if (re.data.statusCode === '200') {
            localStorage.setItem('isreg', 'true')
            this.$message({ message: '注册成功', type: 'success' })
            this.toLogin()
          } else {
            this.$message({
              message: re.data.message,
              type: 'error',
            })
          }
        }
      })
    },
    //当全电操作类型改变
    czlxchange() {
      this.regForm.kpdwdm = ''
      this.regForm.kpdwmc = ''
      this.regForm.dzswjzh = ''
      this.regForm.dzswjmm = ''
      if (this.zclx == 2) {
        this.$confirm('开通全电服务, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {})
          .catch(() => {
            this.zclx = '1'
          })
      }
    },
    goFgPwd() {
      this.loginDialog = false
      this.fgPwdDialog = true
      this.$refs.forgetPasswordDialog.resetFgPwdForm()
    },
    setRegAuthCode(v) {
      this.regForm.authCode = v
    },
    // 登出
    async loginOutConfirm() {
      //   this.$confirm('是否退出登录?', '提示', {
      //   confirmButtonText: '确定',
      //   cancelButtonText: '取消',
      //   type: 'warning',
      // })

      // return

      let _this = this

      this.$confirm('是否退出登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          _this.loginOut()
        })
        .catch(() => {
          _this.$message({
            type: 'info',
            message: '取消退出',
          })
        })
    },
    async loginOut() {
      await API.webLogout()
      this.userLogOut(this)
      // if (re.data.statusCode === '200') {
      //   this.$lstore.remove(USR_TOKEN)
      //   this.setUserInfo({})
      //   this.$router.replace({ name: 'index' }).catch(err => { console.log(err) })
      // }
    },
    // 重置注册表单
    resetRegForm() {
      this.$refs.regForm.resetFields()
      this.regForm.authCode = ''
      this.regForm.areaCode = ''
      this.areaTxt = ''
      this.regForm.hasChkTrt = false
      this.$refs.regAuthCode.clearValue()
    },
    // 返回登录
    toLogin() {
      this.regDialog = false
      setTimeout(() => {
        this.loginDialog = true
      }, 200)
    },
    // 去注册
    goRegister() {
      this.regDialog = true
      this.loginDialog = false
    },
    loginDialOpened() {
      this.changTabIdx(this.selectedLoginDialogtab)
      this.$refs.picAuthCode.getValidateCode()
      this.usrQrAccounts = []
    },
    changTabIdx(v) {
      if (v.name === 'wx') {
        this.getQrCode()
      } else if (v.name === 'pass') {
        this.qRState = ''
        this.usrQrAccounts = []
      }
      this.selectedLoginDialogtab = v
    },
    perfectInfo() {
      if (this.loginDialog) {
        this.loginDialog = false
      }
      this.needMerge = true
      this.perfectInfo()
    },
    // 显示完善信息
    _showCompD() {
      this.needMerge = true
      this.$refs.compAccount.perfectInfo()
      this._hideLogD()
    },
    // toggle comp_acct
    _visUpdate(v) {
      this.needMerge = v
    },
    _hideLogD() {
      this.loginDialog = false
    },
    toLogFromComp() {
      this.activeName = 'pass'
      this.loginDialog = true
      this.$message({ message: '完善信息成功，请登录', type: 'success' })
    },
    async loginSelectedAccount(v) {
      try {
        const res = await API.loginSelectedAccount({
          username: v,
          state: this.qRState,
        })
        if (res.data.statusCode === '200') {
          this.loginSucc(res).then(res => {
            this.$message({
              message: '登录成功',
              type: 'success',
            })
            this.loginDialog = false
          })
        } else {
          throw new Error(res.data.message)
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: 'error',
        })
      }
    },
  },
  components: {
    AuthCode,
    ToggleLoca,
    CompAccount,
    Agreement,
    PicAuthCode,
    ForgetPassword,
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/assets/style/mixin.styl';
@import '~@/assets/style/variable';

.top-header1 {
  width: 100%;
  .el-dropdown-link {
    // color: white;
  }
  .ltr {
      width: 100%;
    flex-ltr-parent();

    ul {
        width: 100%;
      display: flex;
      align-items:center;
    }

    .th-h-phone {
      .icon-phone {
        font-size: 12px;
        padding-right: 6px;
      }
    }

    // .handle, .item {
    //   display: inline-block;

    //   .item {
    //     margin: 0 10px;

    //     &.i-usr-name:hover {
    //       text-decoration: underline;
    //     }

    //     &:hover {
    //       cursor: pointer;
    //       color: theme-color;
    //     }
    //   }
    // }
  }

  .login-dialog {
    .el-dialog__body {
      padding: 10px 20px;
      font-size: 20px;
    }

    .el-dialog__footer {
      padding-top: 0px;
    }

    .login-tabs {
      center();

      .or-tab {
        width: 85%;

        .wrapper {
          width: 90%;
          margin: 15px auto;

          &.b-wrapper {
            center();
            margin-top: 30px;
          }
        }

        .login-btn {
          width: 100%;
        }
      }

      .qr-wrapper {
        // height 200px
        center();
        flex-direction: column;
      }
    }

    .tp-lg-dialog-footer {
      width: 85%;
      margin: 0 auto;
      padding-top: 0;
      flex-ltr-parent();
      color: #999999;
      font-size: 14px;
    }
  }

  .reg-dialog {
    .tp-reg-dia-header {
      font-size: 20px;
      color: theme-color;
    }

    .tp-form-w {
      .tp-rgbt-w {
        margin-top: 20px;
      }

      .tp-buttom-bt {
        center();
      }
    }
  }
}

.login-btn1 {
  color: #ff7a00;
  border: 1px solid #ff7a00;
  border-radius: 18px;
  font-size: 22px;
  margin-right: 10px;
  margin-left:10px;
  width: 70px;
  height: 36px;
  line-height: 36px;
  text-align: center;
  text-decoration: none;

  &:hover {
    cursor: pointer;
    background-color: #ff7a00;
    color: white;
  }
}

.zhuce-btn {
  color: #999999;
  font-size: 22px;
  width: 96px;
  height: 22px;
  line-height: 24px;
  text-align: center;
  text-decoration: none;
  font-family: AdobeHeitiStd-Regular;

  &:hover {
    cursor: pointer;
    color: #ff7a00;
  }
}
.tishi{
  color:#ff7a00;
  margin-left:10px;
  margin-bottom:10px;
}
.no-autofill-pwd {
  /deep/ .el-input__inner {
    -webkit-text-security:disc!important;
  }
}
.left_c{
  margin-left:10px;
}
        .hg-btn {
          margin: 0 0 0 5px;
          color: #ff7a00;
          border: 1px solid #ff7a00;
          border-radius: 15px;
          font-size: 14px;
          margin-right: 8px;
          // padding: 8px 4px;
          width: 80px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          text-decoration: none;

          &:hover {
            cursor: pointer;
            background-color: #ff7a00;
            color: white;
          }
        }
</style>
